// ** saylov
const initialState = {
  body_camera: false
}

const body_camera_state = (state = initialState, action) => {
  switch (action.type) {
    case "BODY_CAMERA":
      return { ...state, body_camera: action.val }
    default:
      return state
  }
}

export default body_camera_state
